import { render, staticRenderFns } from "./dashboard-history-order-item.vue?vue&type=template&id=e10197b6&scoped=true&"
import script from "./dashboard-history-order-item.vue?vue&type=script&lang=js&"
export * from "./dashboard-history-order-item.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-history-order-item.vue?vue&type=style&index=0&id=e10197b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10197b6",
  null
  
)

export default component.exports